import React, { useEffect, useState } from 'react';
import {
    ChevronDownIcon,
    ChevronLeftIcon,
    ChevronUpIcon,
    FilterIcon,
    Moon1Icon,
    Moon2Icon,
    Moon3Icon,
    Moon4Icon, SearchIcon
} from "../../../helper/HwIcon";
import { Range } from "react-range";
import {airlineImageFn, convertHourseFn, convertMinutesFn, formatPrice, formatePriceFn} from "../../../helper/commonFunction";
import {
    AirlineSkeletonSideBar, AirportSkeletonSideBar,
    DurationSkeletonSideBar,
    PriceSkeletonSideBar
} from "../components/FlightSideBarSkeleton";


const FlightListingSidebar = ({
    queryParams,
    jsToogleFilterClickFn,
    headerAirportDataCityAndCountry,
    filterHideShow,
    departureTimeFilter,
    setDepartureTimeFilter,
    totalAirportStops,
    setTotalAirportStops,
    priceRange,
    inputRangeOnChange,
    fastestFlight,
    onclickFastestCheapestFn,
    showSortTabs,
    agentActiveCurrency,
    airlineFilterData,
    setAirlineFilterData,
    currentTabAirport,
    durationValues,
    handleChange,
    airportFilterData,
    setAirportFilterData,
    roundTripDomestic,
    setRoundTripDomestic,
    showViewAs,
    hasSingleFlight,
    hasComboFlight,
    multiFlightOptionsData,
    returnDepartureTimeFilter,
    setreturnDepartureTimeFilter,
    activeStops,
    setActiveStops,
    returnDurationValues,
    returnHandleChange,
    multiCityDepartureTimeFilter,
    multiCityDurationValues,
    setMultiCityDepartureTimeFilter,
    setMultiCityDurationValues,
    durationRangeChange,
    showLoadingAfterLoad,
    mainLoading,
    airlineText,
    setAirlineText,
    displayPrice
}) => {
    const [tempAirlineFilterData, setTempAirlinFilterData] = useState(airlineFilterData);


    useEffect(() => {
        if(!airlineText){
            setTempAirlinFilterData(airlineFilterData);
        }
    },[airlineText])

    useEffect(() => {
        if(airlineText){
            const filteredData = airlineFilterData.filter(item =>
                item?.flightName?.toLowerCase().includes(airlineText?.toLowerCase())
            );
            setTempAirlinFilterData(filteredData);
        }else{
            setTempAirlinFilterData(airlineFilterData)
        }
    },[airlineFilterData])

    // console.log(multiCityDurationValues, multiCityDepartureTimeFilter,roundTripDomestic)

    return (
        <>
            <aside className="hw-search--flightFilter">
                <div className="hw-search--flightFilter__top">
                    <div className="hw-search--flightFilter__action">
                        <div onClick={jsToogleFilterClickFn}
                            className="js-toggleFilter d-flex align-items-center hw-gapy10 hw-text14"><FilterIcon />Filters
                        </div>
                        <button onClick={jsToogleFilterClickFn} className="hw-link hw-link--gray700 hw-link--icon hw-text14"><ChevronLeftIcon />Hide
                        </button>
                    </div>
                </div>
                 <div className='hw-search--flightFilter__bodyBox'>
                <div className="hw-search--flightFilter__body">

{showViewAs ?
                        <div className="hw-search--flightFilter__widget">
                            <div className={`d-flex align-items-center justify-between hw-search--flightFilter__title`}>
                                <span className="hw-fontBold hw-text14 hw-text14">View As</span>
                            </div>
                            <div style={{ display: "flex", background: "#F2F4F9", borderRadius: "1rem", padding: "0.4rem", gap: "0.4rem" }}>
                                {hasSingleFlight ?
                                    <button type="button" onClick={() => setRoundTripDomestic((prev) => ({ ...prev, active: 1 }))} style={{ flex: 1, border: "none", cursor: "pointer", padding: "0.9rem 0.8rem", borderRadius: "0.8rem", fontSize: "1.4rem", fontWeight: 700, fontFamily: "inherit", transition: "all .15s ease", background: roundTripDomestic?.active === 1 ? "#3264FF" : "transparent", color: roundTripDomestic?.active === 1 ? "#fff" : "#5B6577" }}>Single Flight</button>
                                    : null}
                                {hasComboFlight ?
                                    <button type="button" onClick={() => setRoundTripDomestic((prev) => ({ ...prev, active: 2 }))} style={{ flex: 1, border: "none", cursor: "pointer", padding: "0.9rem 0.8rem", borderRadius: "0.8rem", fontSize: "1.4rem", fontWeight: 700, fontFamily: "inherit", transition: "all .15s ease", background: roundTripDomestic?.active === 2 ? "#3264FF" : "transparent", color: roundTripDomestic?.active === 2 ? "#fff" : "#5B6577" }}>Combo Flight</button>
                                    : null}
                            </div>
                        </div>
                        : null}

{showSortTabs ?
                        <div className="hw-search--flightFilter__widget">
                            <div className={`d-flex align-items-center justify-between hw-search--flightFilter__title`}>
                                <span className="hw-fontBold hw-text14 hw-text14">Sort by</span>
                            </div>
                            <div style={{ display: "flex", background: "#F2F4F9", borderRadius: "1rem", padding: "0.4rem", gap: "0.4rem" }}>
                                <button type="button" onClick={() => onclickFastestCheapestFn(false)} style={{ flex: 1, border: "none", cursor: "pointer", padding: "0.9rem 0.8rem", borderRadius: "0.8rem", fontSize: "1.4rem", fontWeight: 700, fontFamily: "inherit", transition: "all .15s ease", background: !fastestFlight ? "#3264FF" : "transparent", color: !fastestFlight ? "#fff" : "#5B6577" }}>Cheapest</button>
                                <button type="button" onClick={() => onclickFastestCheapestFn(true)} style={{ flex: 1, border: "none", cursor: "pointer", padding: "0.9rem 0.8rem", borderRadius: "0.8rem", fontSize: "1.4rem", fontWeight: 700, fontFamily: "inherit", transition: "all .15s ease", background: fastestFlight ? "#3264FF" : "transparent", color: fastestFlight ? "#fff" : "#5B6577" }}>Fastest</button>
                            </div>
                        </div>
                        : null}
                     <div className="hw-search--flightFilter__widget price-widget">
                        <div className={`d-flex align-items-center justify-between hw-search--flightFilter__title`}>
                            <span className="hw-fontBold hw-text14 hw-text14">Price</span>
                        </div>
                        <div className="hw-search--flightFilter__widgetContent">
                            {filterHideShow.price ?
                                <Range
                                    step={1}
                                    min={priceRange.minMaxSetPrice[0]}
                                    max={priceRange.minMaxSetPrice[1]}
                                    values={priceRange.minMaxPrice}
                                    onChange={(newValues) => inputRangeOnChange(newValues)}
                                    renderTrack={({ props, children }) => (
                                        <div
                                            className='hw-range--line'
                                            {...props}
                                            style={{
                                                ...props.style,
                                                height: '0.4rem',
                                                backgroundColor: '#D7D7D7',
                                                borderRadius: '3px',
                                                position: 'relative',
                                            }}
                                        >
                                            <div
                                                style={{
                                                    height: '0.4rem',
                                                    backgroundColor: '#3264FF',
                                                    position: 'absolute',
                                                    left: `${(priceRange.minMaxPrice[0] - priceRange.minMaxSetPrice[0]) / (priceRange.minMaxSetPrice[1] - priceRange.minMaxSetPrice[0]) * 100}%`,
                                                    right: `${100 - ((priceRange.minMaxPrice[1] - priceRange.minMaxSetPrice[0]) / (priceRange.minMaxSetPrice[1] - priceRange.minMaxSetPrice[0]) * 100)}%`,
                                                }}
                                            />
                                            {children}
                                            <span
                                                className="hw-range--text left">{formatePriceFn(agentActiveCurrency, formatPrice(priceRange?.minMaxPrice[0], false, true), displayPrice)}</span>
                                            <span
                                                className="hw-range--text right">{formatePriceFn(agentActiveCurrency, formatPrice(priceRange?.minMaxPrice[1], false, true), displayPrice)}</span>

                                        </div>
                                    )}
                                    renderThumb={({ props, isDragged }, index) => (
                                        <div
                                            {...props}
                                            style={{
                                                ...props.style,
                                                height: '1.4rem',
                                                width: '1.4rem',
                                                backgroundColor: '#EBEFFF',
                                                border: '1px solid #3264FF',
                                                borderRadius: '50%',
                                                cursor: 'grab',
                                                zIndex: 2,
                                            }}
                                        />
                                    )}
                                /> : <PriceSkeletonSideBar />
                            }
                        </div>
                    </div>

                       <div className="hw-search--flightFilter__widget stops-widget">
                        <div className={`d-flex align-items-center justify-between hw-search--flightFilter__title`}>
                            <span className="hw-fontBold hw-text14 hw-text14">Stops</span>
                        </div>
                        {filterHideShow.stops &&
                            <>
                                {((queryParams?.returnDate && roundTripDomestic?.active !== 1) || (queryParams?.segments?.length)) ?
                                    <div className="hw-sidebar-stops--btn">
                                        {activeStops?.length ? activeStops?.map((airport, activeStopindex) => {
                                            if (!airport?.title?.includes('undefined')) {
                                                return (
                                                    <button onClick={() => {
                                                        setActiveStops((prevData) =>
                                                            prevData.map((stop, index) => ({
                                                                ...stop,
                                                                active: index === activeStopindex,
                                                            }))
                                                        )
                                                        setTotalAirportStops((prevData) =>
                                                            prevData.map((stop) => ({
                                                                ...stop,
                                                                checked: false,
                                                            }))
                                                        );
                                                    }} className={`hw-btn hw-btn--smallSize ${airport?.active ? 'hw-btn--primaryOutlineActive' : 'hw-btn--secondaryOutline'}`}>{airport?.title}</button>
                                                )
                                            }

                                        }) : null}
                                    </div>
                                    : null}
                                <div className="hw-search--flightFilter__widgetContent hw-search--flightFilter__stops">
                                    {totalAirportStops?.length ? totalAirportStops?.map((totalAirport, totalAirportIndex) => {
                                        if (queryParams?.directFlight === 'true' && totalAirport?.value > 0) return null;
                                        return (
                                            <span className={totalAirport.checked ? "active" : ""} onClick={() => {
                                                setTotalAirportStops((prevData) => {
                                                    const updatedData = [...prevData];
                                                    updatedData[totalAirportIndex] = {
                                                        ...updatedData[totalAirportIndex],
                                                        checked: !updatedData[totalAirportIndex]?.checked
                                                    };
                                                    return updatedData;
                                                });
                                            }}>{totalAirport.stop}</span>
                                        )
                                    }) : null}
                                </div>
                            </>
                        }
                    </div>

                    {(queryParams?.segments?.length && roundTripDomestic?.active === 2) ? Object.keys(multiCityDepartureTimeFilter)?.length ? Object.keys(multiCityDepartureTimeFilter)?.map((filterData) => {
                        let timeFilterData = multiCityDepartureTimeFilter?.[filterData];
                        let departureTimeFilter = timeFilterData.time;
                        return (
                            <>
                                <div className="hw-search--flightFilter__widget">
                                    <div onClick={() => {
                                        setMultiCityDepartureTimeFilter(prev => ({
                                            ...prev,
                                            [filterData]: {
                                                ...prev[filterData],
                                                departure: !prev[filterData].departure
                                            }
                                        }));
                                    }}
                                        className={`d-flex align-items-center justify-between hw-search--flightFilter__title ${timeFilterData.departure ? "active" : ""} `}>
                                        <span className="hw-fontBold hw-text14"> Departure From {timeFilterData?.city}
                                        </span> {timeFilterData.departure ?
                                            <ChevronUpIcon /> : <ChevronDownIcon />}
                                    </div>
                                    {timeFilterData.departure &&
                                        <div className="hw-search--flightFilter__widgetContent hw-search--flightFilter__iconText">
                                            {departureTimeFilter?.length ? departureTimeFilter?.map((timeFilter, timeIndex) => {
                                                let index = timeIndex + 1;
                                                return (
                                                    <span onClick={() => {
                                                        setMultiCityDepartureTimeFilter(prev => ({
                                                            ...prev,
                                                            [filterData]: {
                                                                ...prev[filterData],
                                                                time: prev[filterData].time.map((item, index) =>
                                                                    index === timeIndex ? { ...item, checked: !item.checked } : item
                                                                )
                                                            }
                                                        }));
                                                    }} className={timeFilter.checked ? "active" : ""}>
                                                        {index === 1 ? <Moon1Icon /> : index === 2 ? <Moon2Icon /> : index === 3 ?
                                                            <Moon3Icon /> : index === 4 ? <Moon4Icon /> : ""}
                                                        {timeFilter?.title}
                                                    </span>
                                                )
                                            }) : null}
                                        </div>
                                    }
                                </div>
                            </>
                        )
                    }) : '' :
                        (roundTripDomestic?.status && roundTripDomestic?.active === 1 && multiFlightOptionsData?.length > 1
                            ? multiFlightOptionsData?.find(flight => flight?.active)?.fromAirport?.city
                            : headerAirportDataCityAndCountry(queryParams?.fromAirport, true)
                        ) ?
                            <>
                                <div className="hw-search--flightFilter__widget">
                                    <div className={`d-flex align-items-center justify-between hw-search--flightFilter__title`}>
                                        <span className="hw-fontBold hw-text14"> Departure From
                                            {(roundTripDomestic?.status && roundTripDomestic?.active === 1 && multiFlightOptionsData?.length > 1) ? ` ${multiFlightOptionsData?.find(flight => flight?.active)?.fromAirport?.city}` : ` ${headerAirportDataCityAndCountry(queryParams?.fromAirport, true)}`}

                                        </span>
                                    </div>
                                    {filterHideShow.departure &&
                                        <div className="hw-search--flightFilter__widgetContent hw-search--flightFilter__iconText">
                                            {departureTimeFilter?.length ? departureTimeFilter?.map((timeFilter, timeIndex) => {
                                                let index = timeIndex + 1;
                                                return (
                                                    <span onClick={() => {
                                                        setDepartureTimeFilter((prevData) => {
                                                            const updatedData = [...prevData];
                                                            updatedData[timeIndex] = {
                                                                ...updatedData[timeIndex],
                                                                checked: !updatedData[timeIndex]?.checked
                                                            };
                                                            return updatedData;
                                                        });
                                                    }} className={timeFilter.checked ? "active" : ""}>
                                                        {index === 1 ? <Moon1Icon /> : index === 2 ? <Moon2Icon /> : index === 3 ?
                                                            <Moon3Icon /> : index === 4 ? <Moon4Icon /> : ""}
                                                        {timeFilter?.title}
                                                    </span>
                                                )
                                            }) : null}
                                        </div>
                                    }
                                </div>
                            </> : ''
                    }



                    {(queryParams?.returnDate && roundTripDomestic?.active !== 1) ?
                        <div className="hw-search--flightFilter__widget">
                            <div className={`d-flex align-items-center justify-between hw-search--flightFilter__title`}>
                                <span className="hw-fontBold hw-text14"> Departure From {headerAirportDataCityAndCountry(queryParams?.toAirport, true)}
                                </span>
                             </div>
                            {filterHideShow.returnDeparture &&
                                <div className="hw-search--flightFilter__widgetContent hw-search--flightFilter__iconText">
                                    {returnDepartureTimeFilter?.length ? returnDepartureTimeFilter?.map((timeFilter, timeIndex) => {
                                        let index = timeIndex + 1;
                                        return (
                                            <span onClick={() => {
                                                setreturnDepartureTimeFilter((prevData) => {
                                                    const updatedData = [...prevData];
                                                    updatedData[timeIndex] = {
                                                        ...updatedData[timeIndex],
                                                        checked: !updatedData[timeIndex]?.checked
                                                    };
                                                    return updatedData;
                                                });
                                            }} className={timeFilter.checked ? "active" : ""}>
                                                {index === 1 ? <Moon1Icon /> : index === 2 ? <Moon2Icon /> : index === 3 ?
                                                    <Moon3Icon /> : index === 4 ? <Moon4Icon /> : ""}
                                                {timeFilter?.title}
                                            </span>
                                        )
                                    }) : null}
                                </div>
                            }
                        </div>
                        : null}


                    <div className="hw-search--flightFilter__widget airlines-widget">
                        <div className={`d-flex align-items-center justify-between hw-search--flightFilter__title`}>
                            <span className="hw-fontBold hw-text14">Airlines</span>
                        </div>
                        <div className="hw-search--flightFilter__widgetContent">
                            <ul className="list-unstyled hw-search--flightCheckbox">
                                {!mainLoading ? <>
                                        <div className="hw-position--relative hw-airline-filter">
                                            <input
                                                value={airlineText}
                                                placeholder="Search Airlines"
                                                className="hw-form--input "
                                                onChange={(event) => {
                                                    const textValue = event.target.value;
                                                    setAirlineText(textValue);
                                                    const filteredData = airlineFilterData.filter(item =>
                                                        item?.flightName?.toLowerCase().includes(textValue.toLowerCase())
                                                    );
                                                    setTempAirlinFilterData(filteredData);
                                                }}
                                            />
                                            <SearchIcon />
                                        </div>
                                        {tempAirlineFilterData?.length ?
                                            tempAirlineFilterData?.map((airlines, airlineIndex) => {
                                                if(airlines?.show){
                                                    return (
                                                        <li>
                                                            <label
                                                                className="hw-airline--grid align-items-center hw-text14 hw-gapy10">
                                                                <input
                                                                    onChange={(e) => {
                                                                        setAirlineFilterData((prevData) =>
                                                                            prevData.map((item) =>
                                                                                item.index === airlines.index
                                                                                    ? { ...item, checked: e.target.checked }
                                                                                    : item
                                                                            )
                                                                        );
                                                                    }}
                                                                    type="checkbox"
                                                                    name="airlines"
                                                                    value={airlines.flightName}
                                                                    checked={airlines.checked}
                                                                />
                                                                <img
                                                                    width={20}
                                                                    height={20}
                                                                    src={airlineImageFn(airlines?.flightCode)}
                                                                    alt={airlines?.flightName}
                                                                    style={{objectFit:"cover"}}
                                                                />
                                                                <span className="hw-black900 hw-text--hidden">{airlines.flightName}</span>{/*<span className="hw-text14">({airlines.count})</span>*/}
                                                            </label>
                                                            <span className="hw-text14 ms-2 white-space-nowrap">{formatePriceFn(agentActiveCurrency, formatPrice(airlines?.totalPrice, false, true), displayPrice)}</span>

                                                        </li>
                                                    )
                                                }
                                            })
                                            : <span className="mt-1 hw-text14">No Airlines</span>}
                                    </>
                                : [1,2,3,4,5].map((i) => (
                                    <AirlineSkeletonSideBar />
                                    ))}
                            </ul>
                        </div>
                    </div>
                    <div className="hw-search--flightFilter__widget duration-widget">
                        <div className={`d-flex align-items-center justify-between hw-search--flightFilter__title`}>
                            <span className="hw-fontBold hw-text14">Duration</span>
                        </div>
                        <div className="hw-search--flightFilter__widgetContent">
                            {(queryParams?.segments?.length && roundTripDomestic?.active === 2) ? Object.keys(multiCityDurationValues)?.length ? Object.keys(multiCityDurationValues)?.map((duration) => {
                                    let durationValues = multiCityDurationValues?.[duration]
                                    return (
                                        <div className="hw-search--flightFilter__frame">
                                            <div className="top hw-black900 hw-text14 hw-text--uppercase hw-fontBold hw-text14">{duration}</div>
                                            <div className="middle hw-fontBold hw-text14 hw-black900 hw-text14">Up
                                                to: {convertHourseFn(durationValues.duration[0])}</div>
                                            <div className="bottom">
                                                <Range
                                                    step={1}
                                                    min={durationValues.minMaxSetValue[0]}
                                                    max={durationValues.minMaxSetValue[1]}
                                                    values={durationValues.duration}
                                                    onChange={(newValues) => {
                                                        durationRangeChange(newValues,duration)
                                                    }}
                                                    renderTrack={({ props, children }) => {
                                                        const percentage = ((durationValues.duration[0] - durationValues.minMaxSetValue[0]) / (durationValues.minMaxSetValue[1] - durationValues.minMaxSetValue[0])) * 100;
                                                        return (
                                                            <div className="hw-range--line"
                                                                 {...props}
                                                                 style={{
                                                                     ...props.style,
                                                                     height: '0.4rem',
                                                                     width: '100%',
                                                                     position: 'relative',
                                                                     background: `linear-gradient(to right, #3264FF ${percentage}%, #D7D7D7 ${percentage}%)`,
                                                                 }}
                                                            >
                                                                {children}
                                                                <span
                                                                    className="hw-range--text left">{convertMinutesFn(durationValues.minMaxSetValue[0])}</span>
                                                                <span
                                                                    className="hw-range--text right">{convertMinutesFn(durationValues.minMaxSetValue[1])}</span>
                                                            </div>
                                                        )
                                                    }}
                                                    renderThumb={({ props }) => (
                                                        <div
                                                            {...props}
                                                            style={{
                                                                ...props.style,
                                                                height: '1.4rem',
                                                                width: '1.4rem',
                                                                borderRadius: '50%',
                                                                backgroundColor: '#EBEFFF',
                                                                border: '1px solid #3264FF'
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    )
                                }) : <DurationSkeletonSideBar /> :
                                showLoadingAfterLoad ? <DurationSkeletonSideBar /> :
                                <div className="hw-search--flightFilter__frame">
                                    <div className="top hw-black900 hw-text14 hw-text--uppercase hw-fontBold hw-text14">{(queryParams?.returnDate && roundTripDomestic?.active !== 1) ? `${queryParams?.fromAirport}-${queryParams?.toAirport}` : currentTabAirport}</div>
                                    <div className="middle hw-fontBold hw-text14 hw-black900 hw-text14">Up
                                        to: {convertHourseFn(durationValues.duration[0])}</div>
                                    <div className="bottom">
                                        <Range
                                            step={1}
                                            min={durationValues.minMaxSetValue[0]}
                                            max={durationValues.minMaxSetValue[1]}
                                            values={durationValues.duration}
                                            onChange={handleChange}
                                            renderTrack={({ props, children }) => {
                                                const percentage = ((durationValues.duration[0] - durationValues.minMaxSetValue[0]) / (durationValues.minMaxSetValue[1] - durationValues.minMaxSetValue[0])) * 100;
                                                return (
                                                    <div className="hw-range--line"
                                                         {...props}
                                                         style={{
                                                             ...props.style,
                                                             height: '0.4rem',
                                                             width: '100%',
                                                             position: 'relative',
                                                             background: `linear-gradient(to right, #3264FF ${percentage}%, #D7D7D7 ${percentage}%)`,
                                                         }}
                                                    >
                                                        {children}
                                                        <span
                                                            className="hw-range--text left">{convertMinutesFn(durationValues.minMaxSetValue[0])}</span>
                                                        <span
                                                            className="hw-range--text right">{convertMinutesFn(durationValues.minMaxSetValue[1])}</span>
                                                    </div>
                                                )
                                            }}
                                            renderThumb={({ props }) => (
                                                <div
                                                    {...props}
                                                    style={{
                                                        ...props.style,
                                                        height: '1.4rem',
                                                        width: '1.4rem',
                                                        borderRadius: '50%',
                                                        backgroundColor: '#EBEFFF',
                                                        border: '1px solid #3264FF'
                                                    }}
                                                />
                                            )}
                                        />
                                    </div>
                                </div>}

                            {(queryParams?.returnDate && roundTripDomestic?.active !== 1) ?
                                <div className="hw-search--flightFilter__frame">
                                    <div className="top hw-black900 hw-text14 hw-text--uppercase hw-fontBold hw-text14">{`${queryParams?.toAirport}-${queryParams?.fromAirport}`}</div>
                                    <div className="middle hw-fontBold hw-text14 hw-black900 hw-text14">Up
                                        to: {convertHourseFn(returnDurationValues.duration[0])}</div>
                                    <div className="bottom">
                                        <Range
                                            step={1}
                                            min={returnDurationValues.minMaxSetValue[0]}
                                            max={returnDurationValues.minMaxSetValue[1]}
                                            values={returnDurationValues.duration}
                                            onChange={returnHandleChange}
                                            renderTrack={({ props, children }) => {
                                                const percentage = ((returnDurationValues.duration[0] - returnDurationValues.minMaxSetValue[0]) / (returnDurationValues.minMaxSetValue[1] - returnDurationValues.minMaxSetValue[0])) * 100;
                                                return (
                                                    <div className="hw-range--line"
                                                         {...props}
                                                         style={{
                                                             ...props.style,
                                                             height: '0.4rem',
                                                             width: '100%',
                                                             position: 'relative',
                                                             background: `linear-gradient(to right, #3264FF ${percentage}%, #D7D7D7 ${percentage}%)`,
                                                         }}
                                                    >
                                                        {children}
                                                        <span
                                                            className="hw-range--text left">{convertMinutesFn(returnDurationValues.minMaxSetValue[0])}</span>
                                                        <span
                                                            className="hw-range--text right">{convertMinutesFn(returnDurationValues.minMaxSetValue[1])}</span>
                                                    </div>
                                                )
                                            }}
                                            renderThumb={({ props }) => (
                                                <div
                                                    {...props}
                                                    style={{
                                                        ...props.style,
                                                        height: '1.4rem',
                                                        width: '1.4rem',
                                                        borderRadius: '50%',
                                                        backgroundColor: '#EBEFFF',
                                                        border: '1px solid #3264FF'
                                                    }}
                                                />
                                            )}
                                        />
                                    </div>
                                </div>
                                : null}
                        </div>
                    </div>
                    <div className="hw-search--flightFilter__widget airport-widget">
                        <div className={`d-flex align-items-center justify-between hw-search--flightFilter__title`}>
                            <span className="hw-fontBold hw-text14">Airport</span>
                        </div>
                        <div className="hw-search--flightFilter__widgetContent">
                            {(queryParams?.segments?.length && roundTripDomestic?.active === 2) ? Object.keys(airportFilterData)?.length ?
                                Object.keys(airportFilterData)?.map((index) => {
                                    let airportData = airportFilterData?.[index];
                                    return (
                                        <div className="hw-search--flightFilter__frame">
                                            <div className="top hw-black900 hw-text14 hw-text--uppercase hw-fontBold hw-text14">{`${airportData?.departure?.[0]?.airportCode}-${airportData?.arrival?.[0]?.airportCode}`}</div>
                                            <div className="middle hw-fontBold hw-text14 hw-black900 hw-text14">{airportData?.departure?.[0]?.airportCode}</div>
                                            <div className="bottom">
                                                <ul className="list-unstyled hw-search--flightCheckbox">
                                                    {airportData?.departure?.length ? airportData?.departure?.map((data, indexData) => {
                                                        return (
                                                            <li>
                                                                <label className="hw-grid--2auto">
                                                                    <input onChange={(e) => {
                                                                        setAirportFilterData((prevData) => {
                                                                            const updatedData = { ...prevData };
                                                                            updatedData[index].departure[indexData].active = e.target.checked;
                                                                            return updatedData;
                                                                        });
                                                                    }} checked={data?.active} type="checkbox" value={data?.active} />
                                                                    <span className="hw-text14 hw-black900 overflow-ellipsis">
                                                                            {`${data?.airportCode} - ${data?.airportName}`}
                                                                        </span>

                                                                </label>
                                                            </li>
                                                        )
                                                    }) : ''}
                                                </ul>
                                            </div>
                                            <div className="middle hw-fontBold hw-text14 hw-black900 hw-text14">{airportData?.arrival?.[0]?.airportCode}</div>
                                            <div className="bottom">
                                                <ul className="list-unstyled hw-search--flightCheckbox">
                                                    {airportData?.arrival?.length ? airportData?.arrival?.map((data, indexData) => {
                                                        return (
                                                            <li>
                                                                <label className="hw-grid--2auto">
                                                                    <input onChange={(e) => {
                                                                        setAirportFilterData((prevData) => {
                                                                            const updatedData = { ...prevData };
                                                                            updatedData[index].arrival[indexData].active = e.target.checked;
                                                                            return updatedData;
                                                                        });
                                                                    }} checked={data?.active} type="checkbox"
                                                                           value={data?.active} />
                                                                    <span className="hw-text14 hw-black900 overflow-ellipsis">
                                                                            {data?.airportCode} - {data?.airportName}
                                                                        </span>
                                                                </label>
                                                            </li>
                                                        )
                                                    }) : ''}

                                                </ul>
                                            </div>
                                        </div>
                                    )
                                }) : <AirportSkeletonSideBar />

                                :
                                showLoadingAfterLoad ?
                                    <AirportSkeletonSideBar />
                                    : <>
                                    <DepartureAirportComponent
                                        multiFlightOptionsData={multiFlightOptionsData}
                                        roundTripDomestic={roundTripDomestic}
                                        airportFilterData={airportFilterData}
                                        queryParams={queryParams}
                                        setAirportFilterData={setAirportFilterData}
                                    />
                                    <ArrivalAirportComponent
                                        multiFlightOptionsData={multiFlightOptionsData}
                                        roundTripDomestic={roundTripDomestic}
                                        airportFilterData={airportFilterData}
                                        queryParams={queryParams}
                                        setAirportFilterData={setAirportFilterData}
                                    />
                                </>}
                        </div>

                    </div>
                    </div>
                </div>
            </aside>
        </>
    )
}

const DepartureAirportComponent = ({
    multiFlightOptionsData,
    roundTripDomestic,
    airportFilterData,
    queryParams,
    setAirportFilterData
}) => {
    let airportFilterArrData = airportFilterData?.departure;
    let findActiveOptionData;
    if (multiFlightOptionsData?.length && roundTripDomestic?.active === 1) {
        findActiveOptionData = multiFlightOptionsData?.find((active) => active?.active)?.type;
        if (findActiveOptionData === "ONWARD") {
            airportFilterArrData = airportFilterData?.departure;
        } else if (findActiveOptionData === "RETURN") {
            airportFilterArrData = airportFilterData?.returnDeparture;
        }
    } else {
        airportFilterArrData = airportFilterData?.departure;
    }

    return (
        <div className="hw-search--flightFilter__frame">
            <div className="top hw-black900 hw-text14 hw-text--uppercase hw-fontBold hw-text14">DEPARTURE</div>
            <div className="middle hw-fontBold hw-text14 hw-black900 hw-text14">{(roundTripDomestic?.status && roundTripDomestic?.active === 1 && multiFlightOptionsData?.length > 1)
                ? multiFlightOptionsData?.find(flight => flight?.active)?.fromAirport?.airportCode
                : queryParams?.fromAirport}</div>
            <div className="bottom">
                <ul className="list-unstyled hw-search--flightCheckbox">

                    {Array.isArray(airportFilterArrData) ? airportFilterArrData?.map((departureData, index) => {
                        return (
                            <li>
                                <label className="hw-grid--2auto">
                                      <input onChange={(e) => {
                                        setAirportFilterData((prevData) => {
                                            const updatedData = { ...prevData };
                                            if (findActiveOptionData === "ONWARD") {
                                                updatedData.departure[index].active = e.target.checked;
                                            } else if (findActiveOptionData === "RETURN") {
                                                updatedData.returnDeparture[index].active = e.target.checked;
                                            } else {
                                                let findAgainActiveOption = multiFlightOptionsData?.find((active) => active?.active)?.type;
                                                if (findAgainActiveOption === "ONWARD" && roundTripDomestic?.active === 1) {
                                                    updatedData.departure[index].active = e.target.checked;
                                                } else if (findAgainActiveOption === "RETURN" && roundTripDomestic?.active === 1) {
                                                    updatedData.returnDeparture[index].active = e.target.checked;
                                                } else {
                                                    updatedData.departure[index].active = e.target.checked;
                                                }
                                            }
                                            return updatedData;
                                        });
                                    }} checked={departureData?.active} type="checkbox"
                                        value={departureData?.active} />
                                    <span className="hw-text14 hw-black900 overflow-ellipsis">
                                        {departureData?.airportCode} - {departureData?.airportName}
                                    </span>

                                </label>
                            </li>
                        )
                    })

                        :
                        <li>
                            <label className="hw-grid--2auto">
                                  <input onChange={(e) => {
                                    setAirportFilterData((prevData) => {
                                        const updatedData = { ...prevData };
                                        updatedData.departure.active = e.target.checked;
                                        return updatedData;
                                    });
                                }} checked={airportFilterData?.departure?.active} type="checkbox"
                                    value={airportFilterData?.departure?.active} />
                                <span className="hw-text14 hw-black900 overflow-ellipsis">
                                    {(roundTripDomestic?.status && roundTripDomestic?.active === 1 && multiFlightOptionsData?.length > 1) ?
                                        `${multiFlightOptionsData?.find(flight => flight?.active)?.fromAirport?.airportCode} - ${multiFlightOptionsData?.find(flight => flight?.active)?.fromAirport?.airportName}`
                                        : `${airportFilterData?.departure?.airportCode} - ${airportFilterData?.departure?.airportName}`}
                                </span>

                            </label>
                        </li>
                    }


                </ul>
            </div>
            {(queryParams?.returnDate && roundTripDomestic?.active !== 1) ?
                <>
                    <div className="middle hw-fontBold hw-text14 hw-black900 hw-text14">{queryParams?.toAirport}</div>
                    <div className="bottom">
                        <ul className="list-unstyled hw-search--flightCheckbox">
                            {Array.isArray(airportFilterData?.returnDeparture) ? airportFilterData?.returnDeparture?.map((departureData, index) => {
                                return (
                                    <li>
                                        <label className="hw-grid--2auto">
                                             <input onChange={(e) => {
                                                setAirportFilterData((prevData) => {
                                                    const updatedData = { ...prevData };
                                                    updatedData.returnDeparture[index].active = e.target.checked;
                                                    return updatedData;
                                                });
                                            }} checked={departureData?.active} type="checkbox"
                                                value={departureData?.active} />
                                            <span className="hw-text14 hw-black900 overflow-ellipsis">
                                                {departureData?.airportCode} - {departureData?.airportName}
                                            </span>

                                        </label>
                                    </li>
                                )
                            }) : ''}
                        </ul>
                    </div>
                </>
                : null}
        </div>
    )
}

const ArrivalAirportComponent = ({
    multiFlightOptionsData,
    roundTripDomestic,
    airportFilterData,
    queryParams,
    setAirportFilterData
}) => {
    let airportFilterArrData = airportFilterData?.arrival;
    let findActiveOptionData;
    if (multiFlightOptionsData?.length && roundTripDomestic?.active === 1) {
        let findActiveOptionData = multiFlightOptionsData?.find((active) => active?.active)?.type;
        if (findActiveOptionData === "ONWARD") {
            airportFilterArrData = airportFilterData?.arrival;
        } else if (findActiveOptionData === "RETURN") {
            airportFilterArrData = airportFilterData?.returnArrival;
        }
    } else {
        airportFilterArrData = airportFilterData?.arrival;
    }

    return (
        <div className="hw-search--flightFilter__frame">
            <div className="top hw-black900 hw-text14 hw-text--uppercase hw-fontBold hw-text14">ARRIVAL</div>
            <div className="middle hw-fontBold hw-text14 hw-black900 hw-text14">{(roundTripDomestic?.status && roundTripDomestic?.active === 1 && multiFlightOptionsData?.length > 1)
                ? multiFlightOptionsData?.find(flight => flight?.active)?.arrivalAirport?.airportCode
                : queryParams?.toAirport}</div>
            <div className="bottom">
                <ul className="list-unstyled hw-search--flightCheckbox">
                    {Array.isArray(airportFilterArrData) ? airportFilterArrData?.map((arrivalData, index) => {
                        return (
                            <li>
                                <label className="hw-grid--2auto">
                                    <input onChange={(e) => {
                                        setAirportFilterData((prevData) => {
                                            const updatedData = { ...prevData };
                                            if (findActiveOptionData === "ONWARD") {
                                                updatedData.arrival[index].active = e.target.checked;
                                            } else if (findActiveOptionData === "RETURN") {
                                                updatedData.returnArrival[index].active = e.target.checked;
                                            } else {
                                                let findAgainActiveOption = multiFlightOptionsData?.find((active) => active?.active)?.type;
                                                if (findAgainActiveOption === "ONWARD" && roundTripDomestic?.active === 1) {
                                                    updatedData.arrival[index].active = e.target.checked;
                                                } else if (findAgainActiveOption === "RETURN" && roundTripDomestic?.active === 1) {
                                                    updatedData.returnArrival[index].active = e.target.checked;
                                                } else {
                                                    updatedData.arrival[index].active = e.target.checked;
                                                }

                                            }
                                            return updatedData;
                                        });

                                    }} checked={arrivalData?.active} type="checkbox"
                                        value={arrivalData?.active} />
                                    <span className="hw-text14 hw-black900 overflow-ellipsis">
                                        {arrivalData?.airportCode} - {arrivalData?.airportName}
                                    </span>

                                </label>
                            </li>
                        )
                    })

                        :
                        <li>
                            <label className="hw-grid--2auto">
                                 <input onChange={(e) => {
                                    setAirportFilterData((prevData) => {
                                        const updatedData = { ...prevData };
                                        updatedData.arrival.active = e.target.checked;
                                        return updatedData;
                                    });
                                }} checked={airportFilterData?.arrival?.active} type="checkbox"
                                    value={airportFilterData?.arrival?.active} />
                                <span className="hw-text14 hw-black900 overflow-ellipsis">
                                    {(roundTripDomestic?.status && roundTripDomestic?.active === 1 && multiFlightOptionsData?.length > 1) ?
                                        `${multiFlightOptionsData?.find(flight => flight?.active)?.arrivalAirport?.airportCode} - ${multiFlightOptionsData?.find(flight => flight?.active)?.arrivalAirport?.airportName}`
                                        : `${airportFilterData?.arrival?.airportCode} - ${airportFilterData?.arrival?.airportName}`}
                                </span>
                               </label>
                        </li>
                    }


                </ul>
            </div>
            {(queryParams?.returnDate && roundTripDomestic?.active !== 1) ?
                <>
                    <div className="middle hw-fontBold hw-text14 hw-black900 hw-text14">{queryParams?.fromAirport}</div>
                    <div className="bottom">
                        <ul className="list-unstyled hw-search--flightCheckbox">
                            {Array.isArray(airportFilterData?.returnArrival) ? airportFilterData?.returnArrival?.map((departureData, index) => {
                                return (
                                    <li>
                                        <label className="hw-grid--2auto">
                                              <input onChange={(e) => {
                                                setAirportFilterData((prevData) => {
                                                    const updatedData = { ...prevData };
                                                    updatedData.returnArrival[index].active = e.target.checked;
                                                    return updatedData;
                                                });
                                            }} checked={departureData?.active} type="checkbox"
                                                value={departureData?.active} />
                                            <span className="hw-text14 hw-black900 overflow-ellipsis">
                                                {departureData?.airportCode} - {departureData?.airportName}
                                            </span>

                                        </label>
                                    </li>
                                )
                            }) : ''}
                        </ul>
                    </div>
                </>
                : null}
        </div>
    )
}


export default FlightListingSidebar;